import { Accessibility } from '@dnd-kit/dom'
import type {
  DragEndEvent as DomDragEndEvent,
  DragOverEvent as DomDragOverEvent,
  DragStartEvent as DomDragStartEvent,
} from '@dnd-kit/dom'

const FOCUSABLE_SELECTORS = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(', ')

export const ELEMENT_ID_ATTR = 'data-element-id'

export const createDndAccessibilityPlugin = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getName: (entity: any) => string | undefined,
): ReturnType<typeof Accessibility.configure> =>
  Accessibility.configure({
    announcements: {
      dragstart({ operation: { source } }: Parameters<DomDragStartEvent>[0]) {
        if (!source) {
          return
        }
        return `Started dragging ${getName(source.data)}`
      },
      dragover({ operation: { source, target } }: Parameters<DomDragOverEvent>[0]) {
        if (!source || !target) {
          return
        }
        return `${getName(source.data)} is over ${getName(target.data)}`
      },
      dragend({ operation: { source, target }, canceled }: Parameters<DomDragEndEvent>[0]) {
        if (!source) {
          return
        }
        if (canceled) {
          return `Dragging canceled`
        }
        return `Dropped ${getName(source.data)} on ${getName(target?.data) ?? 'nothing'}`
      },
    },
    screenReaderInstructions: {
      draggable: 'Use space to lift the item, and use arrow keys to move it.',
    },
  })

export const focusFirstFocusableInElement = (element: string | HTMLElement): void => {
  const container =
    typeof element === 'string'
      ? document.querySelector<HTMLElement>(`[${ELEMENT_ID_ATTR}="${element}"]`)
      : element
  if (!container) {
    return
  }

  const firstFocusable = container.querySelector<HTMLElement>(FOCUSABLE_SELECTORS)
  if (firstFocusable) {
    firstFocusable.focus()
  } else {
    container.focus()
  }
}

export const focusMain = () => {
  const main = document.querySelector('main')
  if (main) {
    main.focus()
  }
}
